import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [version, setVersion] = useState('');

  useEffect(() => {
    let active = true;

    fetch('/config.json')
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!active || !data) return;
        if (typeof data.APP_VERSION === 'string' && data.APP_VERSION.trim()) {
          setVersion(data.APP_VERSION.trim());
        }
      })
      .catch(() => {
        // Keep footer resilient if config is unavailable.
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <footer className="custom-footer">
      <div className="footer-content">
        <p>
          &copy; {currentYear} Neurotraining · cjgames.it
          {version && <span className="footer-version"> · Versione {version}</span>}
        </p>
        <nav className="footer-links" aria-label="Note legali">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Termini</Link>
          <Link to="/imprint">Note legali</Link>
        </nav>
      </div>
    </footer>
  );
}
